import { homeData } from '@/mocks/data';

export default function StatsBar() {
  return (
    <section className="relative -mt-16 z-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {homeData.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}